import React, { useEffect } from "react";
import Filter from "./Filter";
import Loading from "../../../../components/ui/Loading/Loading";
import { VideoTable } from "./video-table";
import { useUploadFile } from "../../../../api/helper/upload-file";
import { useNavigate } from "react-router-dom";
import Button from "../../../../components/ui/Button/Button";
import IntroModal from "./Section/IntroModal";

const VideoBB = () => {
  const navigate = useNavigate();
  const [selectedFilter, setSelectedFilter] = React.useState({});
  const [submittedFilter, setSubmittedFilter] = React.useState({});
  const [searchBy, setSearchBy] = React.useState("title");
  const [searchByValue, setSearchByValue] = React.useState("");
  const [sortFilter, setSortFilter] = React.useState({});
  const [isResetted, setIsResetted] = React.useState(false);
  const [isResetting, setIsResetting] = React.useState(false);
  const filters = { ...submittedFilter, ...sortFilter };
  const resettedFilter = { ...sortFilter };
  const [isSuccessUpload, setIsSuccessUpload] = React.useState(false);
  const [isUploadingCatalog, setIsUploadingCatalog] = React.useState(false);
  const {
    mutate: uploadFile,
    isLoading,
    data: catalog,
    isSuccess,
    reset,
  } = useUploadFile();
  const onChangeSearchBy = (id) => {
    setSearchBy(id);
  };

  const onSubmitFilter = () => {
    setIsResetted(false);
    setSubmittedFilter({
      ...selectedFilter,
      [searchBy]: searchByValue,
    });
  };

  const onResetFilter = () => {
    setSelectedFilter({});
    setSubmittedFilter({});
    setSearchByValue("");
    setIsResetting(true);
    setIsResetted(true);
  };

  useEffect(() => {
    if (isResetting) {
      setTimeout(() => {
        setIsResetting(false);
      }, 500);
    }
  }, [isResetting]);

  const onChangeSearchByValue = (value) => {
    setSearchByValue(value);
  };

  useEffect(() => {
    if (selectedFilter?.orderBy !== undefined) {
      setSortFilter({
        orderBy: selectedFilter["orderBy"],
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedFilter?.orderBy]);

  const handleChangeCatalog = async (event) => {
    const file = event.target.files[0];

    const catalogData = new FormData();
    catalogData.append("file", file);

    try {
      await uploadFile(catalogData);
    } catch (error) {}
  };

  useEffect(() => {
    if (isSuccess) {
      setIsSuccessUpload(true);
      reset();
    }
  }, [isSuccess]);

  React.useEffect(() => {
    if (isLoading) {
      setIsUploadingCatalog(true);
    } else {
      setIsUploadingCatalog(false);
    }
  }, [isLoading]);

  const handleAddVideo = () => {
    navigate("video/register");
  };

  return (
    <>
      {" "}
      {isUploadingCatalog && (
        <div className="w-[-webkit-fill-available] h-full fixed m-auto bg-white z-[99]">
          <Loading />
        </div>
      )}
      <div className="flex justify-end my-4">
        <Button
          text={
            <label htmlFor="catalogFile" className="cursor-pointer">
              카달로그 파일 변경
            </label>
          }
        />
        <input
          id="catalogFile"
          type="file"
          className="hidden"
          onChange={handleChangeCatalog}
        />

        <IntroModal />
        <Button primary text="동영상 등록" onClick={handleAddVideo} />
      </div>
      {isResetting ? (
        <Loading />
      ) : (
        <>
          {isResetted ? (
            <Filter
              onSubmitFilter={onSubmitFilter}
              filter={selectedFilter}
              onFilter={setSelectedFilter}
              onResetFilter={onResetFilter}
              onChangeSearchBy={onChangeSearchBy}
              onChangeSearchByValue={onChangeSearchByValue}
            />
          ) : (
            <Filter
              onSubmitFilter={onSubmitFilter}
              filter={selectedFilter}
              onFilter={setSelectedFilter}
              onResetFilter={onResetFilter}
              onChangeSearchBy={onChangeSearchBy}
              onChangeSearchByValue={onChangeSearchByValue}
            />
          )}
        </>
      )}
      <VideoTable filter={isResetted ? resettedFilter : filters} />
    </>
  );
};

export default VideoBB;
